import axios from 'axios'
import store from '@/store';
const instance = axios.create({
    headers: {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*'
    }
})


instance.interceptors.request.use(
    (config) => {
        let token = store.state.oidcStore.access_token;
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        config.baseURL = store.state.settings.apiUrl;
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

export default instance;